module.exports = __webpack_public_path__ + "img/tip_bg.05354694.png";